function getCompareAttributes() {
  if (
    Array.isArray(window.compareAttributes) &&
    window.compareAttributes.length
  ) {
    return window.compareAttributes;
  }

  return [];
}


function refreshProductCountVar() {
  const compare = JSON.parse(localStorage.getItem("compareList")) || [];
  const len = compare.length;

  document.documentElement.style.setProperty("--product-count", len);

  document.querySelectorAll(".compare-count-bubble").forEach(bubble => {
    bubble.textContent = len;
    bubble.classList.toggle("hidden", len <= 0);
  });
}


function addToCompare(product) {
  let compare = JSON.parse(localStorage.getItem("compareList")) || [];

  if (!compare.find(p => p.handle === product.handle)) {
    compare.push(product);
    localStorage.setItem("compareList", JSON.stringify(compare));
  }

  refreshProductCountVar();
  updateCompareButtons();

  if (document.getElementById("compare-table")) {
    renderCompareTable();
  }
}


function removeFromCompare(handle) {
  let compare = JSON.parse(localStorage.getItem("compareList")) || [];

  compare = compare.filter(p => p.handle !== handle);
  localStorage.setItem("compareList", JSON.stringify(compare));

  refreshProductCountVar();
  updateCompareButtons();

  if (document.getElementById("compare-table")) {
    renderCompareTable();
  }
}


/*
 * Get current BSS B2B price from the same product card.
 *
 * Example:
 * <span class="bss-b2b-price-no-vat">
 *   142,41 €
 *   <span class="excl-price">exkl. MwSt</span>
 * </span>
 *
 * Returns only:
 * 142,41 €
 */
function getCompareProductPrice(btn) {
  const card = btn.closest(
    ".card-wrapper, .product-card-wrapper, .grid__item"
  );

  if (card) {
    const bssPrice = card.querySelector(".bss-b2b-price-no-vat");

    if (bssPrice) {
      const clone = bssPrice.cloneNode(true);

      clone.querySelectorAll(
        ".excl-price, .incl-price"
      ).forEach(el => el.remove());

      const price = clone.textContent
        .replace(/\s+/g, " ")
        .trim();

      if (price) {
        return price;
      }
    }
  }

  /*
   * Fallback to original Shopify Liquid price
   * if BSS price does not exist.
   */
  return btn.dataset.productPrice || "";
}


function buildCompareProductFromButton(btn) {
  const product = {
    handle: btn.dataset.productHandle || "",
    title: btn.dataset.productTitle || "",
    url: btn.dataset.productUrl || "",
    image: btn.dataset.productImage || "",
    vendor: btn.dataset.productVendor || "",

    /*
     * Get price directly from BSS rendered HTML.
     */
    price: getCompareProductPrice(btn)
  };


  Array.from(btn.attributes).forEach(attr => {
    if (!attr.name.startsWith("data-product-")) return;

    const key = attr.name.replace("data-product-", "");

    if (
      key === "handle" ||
      key === "title" ||
      key === "url" ||
      key === "image" ||
      key === "vendor" ||
      key === "price" ||
      key === "id" ||
      key === "variant-id" ||
      key === "original-price"
    ) {
      return;
    }

    product[key] = attr.value || "";
  });


  return product;
}


function renderCompareTable() {
  const compare = JSON.parse(localStorage.getItem("compareList")) || [];
  const container = document.getElementById("compare-table");

  if (!container) return;


  if (compare.length === 0) {
    container.innerHTML = "<p>No products to compare.</p>";
    return;
  }


  const attributes = getCompareAttributes();


  let html = `
    <div class="compare-header">
      <div class="compare-col attribute-col"></div>

      ${compare.map(p => `
        <div class="compare-col product-col">

          ${
            p.image
              ? `
                <img
                  src="${escapeHtml(p.image)}"
                  class="compare-img"
                  alt="${escapeHtml(p.title)}"
                >
              `
              : ""
          }

          <h4>${escapeHtml(p.title)}</h4>

          <p class="vendor">
            ${escapeHtml(p.vendor)}
          </p>

          <p class="price">
            ${escapeHtml(p.price)}
            <span>exkl. MwSt</span>
          </p>

        </div>
      `).join("")}
    </div>
  `;


  html += `<div class="compare-rows">`;


  attributes.forEach(attr => {
    html += `
      <div class="compare-row">

        <div class="compare-col attribute-col">
          <strong>${escapeHtml(attr.label)}</strong>
        </div>

        ${compare.map(p => {
          const value = p[attr.key] || "";

          return `
            <div class="compare-col value-col">
              ${
                value !== ""
                  ? escapeHtml(value)
                  : `<span class="xmark"></span>`
              }
            </div>
          `;
        }).join("")}

      </div>
    `;
  });


  html += `</div>`;


  const currentLang =
    window.Shopify && Shopify.locale
      ? Shopify.locale
      : document.documentElement.lang;


  const t =
    currentLang &&
    currentLang.toLowerCase().startsWith("en")
      ? {
          product: "View product",
          remove: "Remove"
        }
      : {
          product: "Zum Produkt",
          remove: "Entfernen"
        };


  html += `
    <div class="compare-footer">

      <div class="compare-col attribute-col"></div>

      ${compare.map(p => `
        <div class="compare-col product-col">

          <a
            href="${escapeHtml(p.url)}"
            class="btn-product button button--primary"
          >
            ${t.product}
          </a>

          <button
            class="remove-compare-inline hidden"
            data-handle="${escapeHtml(p.handle)}"
          >
            ${t.remove}
          </button>

        </div>
      `).join("")}

    </div>
  `;


  container.innerHTML = html;


  container
    .querySelectorAll(".remove-compare-inline")
    .forEach(btn => {

      btn.addEventListener("click", function () {
        removeFromCompare(this.dataset.handle);
      });

    });
}


function updateCompareButtons() {
  const compare = JSON.parse(localStorage.getItem("compareList")) || [];


  document.querySelectorAll(".btn-compare").forEach(btn => {
    const handle = btn.dataset.productHandle;

    const isActive = compare.find(
      p => p.handle === handle
    );

    btn.classList.toggle("active", !!isActive);
  });
}


function escapeHtml(str) {
  if (!str) return "";

  return String(str)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}


document.addEventListener("click", function (e) {
  const btn = e.target.closest(".btn-compare");

  if (!btn) return;


  let compare =
    JSON.parse(localStorage.getItem("compareList")) || [];


  const handle = btn.dataset.productHandle;

  if (!handle) return;


  const exists = compare.find(
    p => p.handle === handle
  );


  if (exists) {

    compare = compare.filter(
      p => p.handle !== handle
    );

  } else {

    if (compare.length >= 8) {

      const currentLang =
        window.Shopify && Shopify.locale
          ? Shopify.locale
          : document.documentElement.lang;


      alert(
        currentLang &&
        currentLang.toLowerCase().startsWith("en")
          ? "You can compare a maximum of 8 products."
          : "Sie können maximal 8 Produkte vergleichen."
      );

      return;
    }


    /*
     * IMPORTANT:
     *
     * Price is read HERE, exactly when Compare is clicked.
     *
     * It reads:
     * .bss-b2b-price-no-vat
     *
     * from the same product card.
     */
    const product =
      buildCompareProductFromButton(btn);


    compare.push(product);
  }


  localStorage.setItem(
    "compareList",
    JSON.stringify(compare)
  );


  updateCompareButtons();
  refreshProductCountVar();


  if (document.getElementById("compare-table")) {
    renderCompareTable();
  }
});


document.addEventListener("DOMContentLoaded", () => {

  refreshProductCountVar();
  updateCompareButtons();


  if (document.getElementById("compare-table")) {
    renderCompareTable();
  }

});